export default __webpack_public_path__ + "static/media/hero-image-3.c93b422d.png";